import { useEffect, useState } from "react";
import { aiAgentApi } from "../lib/aiAgentApi";

export const useAiUsageSummary = (pollMs = 60000) => {
    const [usage, setUsage] = useState(null);
    useEffect(() => {
        let cancelled = false;
        const fetch = async () => {
            try {
                const s = await aiAgentApi.stats();
                if (!cancelled) setUsage(s);
            } catch (_) { /* silencioso */ }
        };
        fetch();
        const t = setInterval(fetch, pollMs);
        return () => { cancelled = true; clearInterval(t); };
    }, [pollMs]);
    return usage;
};

export default useAiUsageSummary;
